import Rating from "../../../../Atoms/Rating";
import PhantomButton from "../../../../Atoms/PhantomButton";

interface Props {
  avgStars: number | null;
  totalRecords: number;
  onOpenReviews: (e: any) => void;
}

export default function Stats({
  avgStars,
  totalRecords,
  onOpenReviews,
}: Props) {
  return totalRecords > 0 && avgStars ? (
    <span style={{ display: "flex", alignItems: "center" }}>
      <span style={{ marginLeft: -4 }}>
        <Rating value={Math.round(avgStars)} />
      </span>
      <span style={{ marginLeft: 18 }}>
        <PhantomButton onClick={onOpenReviews}>
          See all {totalRecords} reviews
        </PhantomButton>
      </span>
    </span>
  ) : null;
}
